import { render, staticRenderFns } from "./TransactionsItemTopView.vue?vue&type=template&id=70c7dc3c&scoped=true&"
import script from "./TransactionsItemTopView.vue?vue&type=script&lang=js&"
export * from "./TransactionsItemTopView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsItemTopView.vue?vue&type=style&index=0&id=70c7dc3c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c7dc3c",
  null
  
)

export default component.exports